module.exports = __webpack_public_path__ + "pushu_banner.png?bc37fb31fd174a71c7ac8934b5f15e44";